import { render, staticRenderFns } from "./SimiaWelcomeModal.vue?vue&type=template&id=7d3da1e3&scoped=true"
import script from "./SimiaWelcomeModal.vue?vue&type=script&lang=js"
export * from "./SimiaWelcomeModal.vue?vue&type=script&lang=js"
import style0 from "./SimiaWelcomeModal.vue?vue&type=style&index=0&id=7d3da1e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3da1e3",
  null
  
)

export default component.exports